"use strict";

var Slider = require('./src/slider');
var G2 = require('g2');
if (G2 && G2.Plugin) {
  var Plugin = G2.Plugin;
  Plugin.slider = Slider;
} else {
  console.err('Please load the G2 script first!');
}
module.exports = Slider;



//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/node_modules/_g2-plugin-slider@1.2.1@g2-plugin-slider/index.js
// module id = 610
// module chunks = 0